// frontend/src/api.js

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export async function getHello() {
  const response = await fetch(`${API_BASE_URL}/api/hello`);
  if (!response.ok) throw new Error('Network response was not ok');
  return response.json();
}
